import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

const SECTIONS = [
  {
    n: "1",
    title: "Identification de la société",
    body: [
      "Les présentes Conditions Générales de Vente (ci-après « CGV ») sont éditées par la société Luxury Signs Sàrl, société à responsabilité limitée de droit suisse, représentée par son associé-gérant Monsieur Ludovic Simeray, dont le siège social est situé Avenue de Frontenex 8, 1207 Genève, Suisse, immatriculée au registre du commerce sous le numéro IDE CHE-148.379.827 et assujettie à la taxe sur la valeur ajoutée sous le numéro CHE-148.379.827.",
      "La société exploite notamment le site internet www.smartxglass.ch, destiné à la commercialisation de solutions de films intelligents (smart film / film LCD), de dispositifs de commande, de transformateurs électriques ainsi que d'accessoires associés.",
      "Le client peut contacter la société pour toute information relative aux produits, à leur utilisation ou à une commande en cours, à l'adresse électronique contact@smartxglass.ch ou par téléphone au +41 76 222 36 03. La société s'efforce de répondre dans des délais raisonnables, sans que cela constitue une obligation de résultat.",
    ],
  },
  {
    n: "2",
    title: "Objet et champ d'application",
    body: [
      "Les présentes CGV ont pour objet de définir, de manière détaillée, les conditions contractuelles applicables à toute vente de produits proposée par la société, ainsi que les droits et obligations respectifs des parties dans le cadre de la conclusion, de l'exécution et de la résiliation éventuelle du contrat.",
      "Elles s'appliquent à l'ensemble des ventes conclues à distance, notamment via le site internet, mais également à toute commande passée par voie électronique, téléphonique ou par tout autre moyen.",
      "Le client reconnaît expressément avoir pris connaissance des présentes CGV avant la validation de sa commande et les accepter sans réserve. Elles prévalent sur tout autre document ou condition générale d'achat du client, sauf acceptation expresse et écrite de la société.",
    ],
  },
  {
    n: "3",
    title: "Nature des produits",
    body: [
      "Les produits commercialisés par la société sont des équipements techniques à forte spécificité, intégrant des composants électroniques et destinés à être appliqués sur des surfaces vitrées dans des environnements variés (tertiaire, résidentiel, commercial, etc.).",
      "Les films intelligents permettent, par alimentation électrique, de modifier instantanément leur état visuel (opaque / transparent), ce qui implique une parfaite maîtrise de leur installation et de leur environnement d'exploitation.",
      "Le client est expressément informé que ces produits ne constituent pas des produits standards mais des solutions techniques nécessitant une étude préalable, une mise en œuvre adaptée et un respect strict des conditions d'installation.",
      "Par ailleurs, les produits étant fabriqués sur mesure selon les spécifications fournies par le client, ils ne peuvent en aucun cas être remis en stock, revendus ou réaffectés, ce qui exclut toute possibilité de retour sauf défaut avéré de fabrication.",
    ],
  },
  {
    n: "4",
    title: "Responsabilité du client",
    body: [
      "Le client reconnaît qu'il lui incombe de procéder à toutes les vérifications techniques nécessaires avant de passer commande, notamment en ce qui concerne les dimensions, la configuration du support et les conditions d'installation.",
      "Il est notamment responsable :",
    ],
    list: [
      "de la prise de mesures précises et adaptées, incluant les tolérances nécessaires",
      "de la qualité du vitrage (simple, double, feuilleté, trempé, etc.)",
      "de la planéité et de la propreté de la surface de pose",
      "des conditions climatiques et environnementales du lieu d'installation",
      "de la compatibilité de l'installation électrique",
    ],
    after: [
      "La société ne procédant à aucune validation technique approfondie sauf demande spécifique, elle ne saurait être tenue responsable des conséquences liées à des informations erronées ou incomplètes fournies par le client.",
      "Toute erreur, négligence ou mauvaise appréciation du client exclut toute responsabilité de la société.",
    ],
  },
  {
    n: "5",
    title: "Commande",
    body: [
      "Toute commande validée par le client constitue un engagement ferme et définitif.",
      "En raison du caractère personnalisé des produits, aucune modification, suspension ou annulation ne pourra être acceptée après validation, sauf accord exceptionnel et écrit de la société.",
      "La société se réserve le droit de refuser toute commande présentant un caractère anormal, suspect ou incompatible avec ses capacités techniques ou logistiques.",
    ],
  },
  {
    n: "6",
    title: "Prix",
    body: [
      "Les prix sont exprimés en francs suisses (CHF), toutes taxes comprises, hors frais de livraison et d'éventuels frais annexes (douane, importation, installation, etc.).",
      "Ils peuvent être ajustés en fonction des contraintes techniques, des dimensions, des finitions, des quantités ou de toute exigence spécifique du client.",
      "En cas d'erreur manifeste de prix résultant notamment d'un dysfonctionnement technique ou humain, la société se réserve le droit d'annuler la commande après en avoir informé le client.",
    ],
  },
  {
    n: "7",
    title: "Modalités de paiement",
    body: [
      "Le paiement est exigible en totalité au moment de la validation de la commande, sauf conditions particulières convenues par écrit.",
      "La production des produits ne débute qu'à réception effective des fonds.",
      "La société se réserve le droit de suspendre ou d'annuler toute commande en cas de non-paiement ou de paiement incomplet.",
    ],
  },
  {
    n: "8",
    title: "Fabrication et délais",
    body: [
      "Les produits étant fabriqués sur mesure, les délais de fabrication dépendent de nombreux facteurs, notamment la complexité du projet, les volumes commandés, les délais d'approvisionnement et les contraintes logistiques.",
      "Les délais indiqués sont donnés à titre purement indicatif.",
      "Aucun retard, même significatif, ne pourra donner lieu à indemnisation, pénalité ou résiliation de la commande.",
    ],
  },
  {
    n: "9",
    title: "Livraison et transfert des risques",
    body: [
      "Les produits sont expédiés via des transporteurs tiers choisis par la société.",
      "Le transfert des risques intervient dès la remise des marchandises au transporteur, indépendamment du mode de livraison ou du paiement des frais de transport.",
      "À compter de ce moment, le client assume l'ensemble des risques liés aux produits.",
    ],
  },
  {
    n: "10",
    title: "Réception des marchandises",
    body: [
      "Le client est tenu de procéder à un contrôle rigoureux des marchandises dès leur réception.",
      "Toute anomalie doit être mentionnée de manière précise sur le bon de livraison en présence du transporteur.",
      "Ces réserves doivent être confirmées par écrit dans un délai de 48 heures.",
      "À défaut de respect de cette procédure, les produits seront considérés comme acceptés sans réserve.",
    ],
  },
  {
    n: "11",
    title: "Absence de droit de rétractation",
    body: [
      "Les produits étant réalisés sur mesure, le client reconnaît expressément qu'il ne bénéficie d'aucun droit de rétractation.",
      "Aucun retour, échange ou remboursement ne pourra être accepté.",
    ],
  },
  {
    n: "12",
    title: "Installation",
    body: [
      "L'installation des produits constitue une étape critique nécessitant des compétences techniques spécifiques.",
      "Elle doit être réalisée dans un environnement maîtrisé, propre, sec et conforme aux recommandations techniques.",
      "La société recommande vivement de faire appel à un professionnel qualifié.",
      "Toute installation réalisée dans des conditions inadaptées ou par une personne non qualifiée relève de la seule responsabilité du client.",
    ],
  },
  {
    n: "13",
    title: "Conditions électriques",
    body: [
      "Le bon fonctionnement des produits dépend directement de la qualité de l'alimentation électrique.",
      "Le client doit s'assurer que son installation est conforme aux normes en vigueur, correctement protégée et adaptée aux spécifications des produits.",
      "Toute défaillance résultant d'un défaut électrique (surtension, mauvais câblage, absence de protection, etc.) exclut toute garantie.",
    ],
  },
  {
    n: "14",
    title: "Conditions d'utilisation et d'installation – Environnement et étanchéité",
    body: [
      "Les films intelligents (film LCD) commercialisés par la société sont des produits techniques non étanches, nécessitant des conditions d'installation strictes afin de garantir leur bon fonctionnement et leur durabilité.",
      "À ce titre, il est impératif que le film fasse l'objet, lors de sa pose, d'une finition périphérique complète au moyen d'un joint d'étanchéité au pH neutre, appliqué sur l'intégralité du pourtour du film.",
      "Ce joint a pour fonction d'assurer la protection du film contre les infiltrations d'air, d'humidité et de poussières, et constitue une condition essentielle de conformité de l'installation.",
    ],
    warning: "Il est expressément précisé que :",
    list: [
      "l'utilisation d'un joint non adapté (acide, silicone standard non neutre, ou produit inapproprié) est strictement interdite",
      "l'utilisation d'eau ou de tout liquide pour le lissage du joint est formellement proscrite",
      "toute absence de joint, mauvaise application ou non-respect de ces prescriptions entraînera la perte immédiate de toute garantie",
    ],
    after: [
      "Le client reconnaît le caractère essentiel de ces obligations et s'engage à les respecter ou à les faire respecter par tout intervenant.",
    ],
  },
  {
    n: "15",
    title: "Garantie",
    body: [
      "La garantie couvre uniquement les défauts internes de fabrication.",
      "Elle ne s'applique pas aux défauts liés à :",
    ],
    list: ["l'installation", "l'environnement", "l'utilisation"],
    after: ["La charge de la preuve incombe au client."],
  },
  {
    n: "16",
    title: "Limitation de responsabilité",
    body: [
      "La responsabilité de la société est strictement limitée au montant de la commande.",
      "Aucun dommage indirect ou immatériel ne pourra être indemnisé.",
    ],
  },
  {
    n: "17",
    title: "Force majeure",
    body: [
      "La société ne pourra être tenue responsable en cas d'événement échappant à son contrôle, empêchant l'exécution normale du contrat.",
    ],
  },
  {
    n: "18",
    title: "Données personnelles",
    body: ["Les données sont traitées conformément à la législation suisse (nLPD)."],
  },
  {
    n: "19",
    title: "Droit applicable et juridiction",
    body: [
      "Les présentes CGV sont régies par le droit suisse.",
      "Tout litige relève de la compétence exclusive des tribunaux de Genève.",
    ],
  },
];

export default function CGV() {
  return (
    <main data-testid="cgv-page" className="bg-[#0a0a0a] text-[#f4ede0]">
      <Navbar onCartClick={() => (window.location.href = "/#configurateur")} />

      <section className="luxe-bg pt-32 pb-20">
        <div className="max-w-[900px] mx-auto px-4 sm:px-6 lg:px-12">
          <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#cbc1ad] hover:text-[#d89557] transition mb-10">
            <ArrowLeft className="w-4 h-4" /> Retour
          </Link>

          <header className="mb-14">
            <span className="text-xs uppercase tracking-[0.32em] text-[#d89557]">· Mentions légales ·</span>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#f4ede0] mt-4 sm:mt-6 leading-[1.05]">
              Conditions <span className="italic copper-text">Générales</span> de Vente
            </h1>
            <p className="text-[#7a716a] text-xs uppercase tracking-[0.22em] mt-6">
              Luxury Signs Sàrl · Genève, Suisse · IDE CHE-148.379.827
            </p>
          </header>

          <div className="space-y-12">
            {SECTIONS.map((s) => (
              <article key={s.n} data-testid={`cgv-section-${s.n}`} className="border-t border-[#2a2422] pt-8">
                <h2 className="font-display text-2xl sm:text-3xl text-[#f4ede0] mb-4 leading-tight">
                  <span className="copper-text mr-3">{s.n}.</span>
                  {s.title}
                </h2>
                <div className="space-y-4 text-[#cbc1ad] text-sm sm:text-base leading-relaxed">
                  {(s.body || []).map((p) => (
                    <p key={p}>{p}</p>
                  ))}
                  {s.warning && (
                    <p className="text-[#d89557] flex items-start gap-2 pt-2">
                      <span aria-hidden>⚠️</span>
                      <span>{s.warning}</span>
                    </p>
                  )}
                  {s.list && (
                    <ul className="list-none space-y-2 pl-4 border-l border-[#b87333]/30">
                      {s.list.map((li) => (
                        <li key={li} className="text-[#cbc1ad] before:content-['—'] before:mr-3 before:text-[#d89557]">
                          {li}
                        </li>
                      ))}
                    </ul>
                  )}
                  {(s.after || []).map((p) => (
                    <p key={p}>{p}</p>
                  ))}
                </div>
              </article>
            ))}
          </div>

          <div className="hairline mt-16 mb-8" />
          <p className="text-xs uppercase tracking-[0.22em] text-[#7a716a] text-center">
            En validant une commande, le client confirme avoir lu et accepté les présentes Conditions Générales de Vente.
          </p>
        </div>
      </section>

      <Footer />
    </main>
  );
}
